'use es6';

import { RaiseLoading } from '../../../../trap/LoadingTrap';
import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';

/**
 * TODO: Remove all of raise loading and simplify it...
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ReportLoading = props => /*#__PURE__*/_jsx(Flex, {
  flexDirection: "column",
  flexGrow: 1,
  "data-status-id": "report-status-loading",
  "data-test-id": "reporting-visualization-report",
  children: /*#__PURE__*/_jsx(RaiseLoading, Object.assign({}, props))
});
ReportLoading.propTypes = {
  'data-test-id': PropTypes.string
};
export default ReportLoading;